import { useContext, useEffect, useState } from 'react';
import './login.css';
import { useUserAuth } from './userAuthContext';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import Logo from '../logo/Logo';
import { UsernameContext } from './usernameContext';
export default function SignUp(){
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState("");
    const [password,setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const {signup} = useUserAuth();
    const [error, setErr] = useState("");
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        if(!username){
            setErr("Enter a username");
            return;
        }
        if(password!==confirmPassword){
            setErr("Password doesn't match confirm passworrd");
            return;
        }
        
        try {
            await(signup(email, password));
            if(username){
                if(!localStorage.getItem('userlists')){
                    const tempArr = [];
                    const tempObj = {};
                    tempObj[email] = username;
                    tempArr.push(tempObj);
                    localStorage.setItem('userlists', JSON.stringify(tempArr));
                }else{
                    const tempArr = JSON.parse(localStorage.getItem('userlists'));
                    const tempObj = {...tempArr[0]}
                    tempObj[`${email}`]=username;
                    const temparr = [];
                    temparr.push(tempObj);
                    localStorage.setItem('userlists', JSON.stringify(temparr));
                }
            }
            navigate('/login');
        }catch(err) {
            setErr(err.message);
        }
    }
    useEffect(()=>{
        if(username){
            setErr("");
        }
    }, [username]);
    useEffect(()=>{
        if(password===confirmPassword){
            setErr("");
        }
    }, [password, confirmPassword])
    return (
        <div className='signup'>
            <div className='signup-box'>
                <div className='logo-box2'>
                <Logo />
                </div>
                <div className="signup-content">
                    <form onSubmit={handleSubmit}>
                        <div className='signup-inside'>
                            <label htmlFor='username'>Enter Username</label>
                            <input type='text' id='username' placeholder='Enter username' className='logUser' onChange={(e)=>setUsername(e.target.value)}/>
                            <label htmlFor="user-email"><p>Enter your email</p></label>
                            <input type="text" id="user-email" placeholder="Enter email" className='logUser' onChange={(e)=>setEmail(e.target.value) } />
                            <label htmlFor="userPass"><p>Enter password</p></label>
                            <input type="password" id="userPass" placeholder="Enter password" className='logUser' onChange={(e)=>setPassword(e.target.value)} />
                            <label htmlFor='confirm'>Confirm Password</label>
                            <input type="password" id="confirm" placeholder="Confirm password" className='logUser' onChange={(e)=>setConfirmPassword(e.target.value)} />
                            <br />
                            <button type='submit' id='logSubmit'>Signup</button>
                        </div>
                    </form>
                    <p style={{color:'red', textAlign:'center'}}>{error}</p>
                </div>
                <p className='already'>Alraedy have an account?  <Link to='/login' style={{color:"blue", textDecoration:'underline'}}>Sign In</Link></p>
            </div>
        </div>
    )
}